import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/szechenyi2020_logo.png")